module.exports = __webpack_public_path__ + "media/src/assets/images/simulation-bg-bf8b3925863a278a328f7d9add2ba77b.jpg";